import type { ReactNode } from 'react';
import { useRef } from 'react';

import { cn } from '../../lib/utils';

interface MarqueeTextProps {
  className?: string;
  children: ReactNode;
}

export function MarqueeText({ className, children }: MarqueeTextProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const isDraggingRef = useRef(false);
  const startXRef = useRef(0);
  const scrollLeftRef = useRef(0);
  const userSelectRef = useRef('');

  return (
    <div
      className={cn(
        'relative w-full min-w-0 overflow-x-auto whitespace-nowrap',
        'scrollbar-none touch-pan-x select-text cursor-grab active:cursor-grabbing',
        className
      )}
      ref={scrollRef}
      draggable={false}
      onPointerDown={(event) => {
        if (event.button !== 0 || !scrollRef.current) return;
        isDraggingRef.current = true;
        startXRef.current = event.clientX;
        scrollLeftRef.current = scrollRef.current.scrollLeft;
        userSelectRef.current = scrollRef.current.style.userSelect;
        scrollRef.current.style.userSelect = 'none';
        scrollRef.current.setPointerCapture(event.pointerId);
        event.preventDefault();
      }}
      onPointerMove={(event) => {
        if (!isDraggingRef.current || !scrollRef.current) return;
        const delta = event.clientX - startXRef.current;
        scrollRef.current.scrollLeft = scrollLeftRef.current - delta;
        event.preventDefault();
      }}
      onPointerUp={(event) => {
        if (!scrollRef.current) return;
        isDraggingRef.current = false;
        scrollRef.current.style.userSelect = userSelectRef.current;
        scrollRef.current.releasePointerCapture(event.pointerId);
      }}
      onPointerCancel={(event) => {
        if (!scrollRef.current) return;
        isDraggingRef.current = false;
        scrollRef.current.style.userSelect = userSelectRef.current;
        scrollRef.current.releasePointerCapture(event.pointerId);
      }}
    >
      <span className="inline-flex min-w-0 items-center">{children}</span>
    </div>
  );
}
